<script setup lang="ts">
// A consistent dashboard empty state — an icon, a title and an optional line.
// `positive` tone means "empty is good news" (nothing overdue, nobody waiting);
// `neutral` is a plain no-data state.
withDefaults(
  defineProps<{
    icon?: string; // SVG path `d` (monochrome heroicon)
    image?: string; // URL of a full-colour illustration (overrides `icon`)
    title: string;
    message?: string;
    tone?: "positive" | "neutral";
  }>(),
  { tone: "neutral", message: undefined, icon: undefined, image: undefined },
);
</script>

<template>
  <div class="flex flex-col items-center gap-1.5 px-4 py-8 text-center">
    <img
      v-if="image"
      :src="image"
      :alt="title"
      class="h-20 w-20"
    >
    <svg
      v-else
      class="h-8 w-8"
      :class="tone === 'positive' ? 'text-semantic-success' : 'text-neutral-300'"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        :d="icon"
      />
    </svg>
    <p class="text-sm font-semibold text-neutral-700">
      {{ title }}
    </p>
    <p
      v-if="message"
      class="max-w-xs text-xs text-neutral-500"
    >
      {{ message }}
    </p>
  </div>
</template>
